import {SupabaseInstance} from '../utils';

export type DefaultDeleteDataT = {
  removed_by: string;
  modified_by: string;
  date_modified: string;
  date_removed: string;
};

/**
 * This function is used to get the fields that are needed to update a deleted record.
 * @returns {Promise<DefaultDeleteDataT>} - The delete data.
 */
export const defaultDeleteData = async (): Promise<DefaultDeleteDataT> => {
  const {id} = await SupabaseInstance.getCurrentUser();
  const modified_by = id;
  const removed_by = id;
  const date_modified = new Date().toISOString();
  const date_removed = new Date().toISOString();

  return {
    removed_by,
    modified_by,
    date_modified,
    date_removed,
  };
};
